export { default } from './LoanNavigationTabs';
